// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"ChatWifiBox_contentWrapper__17rCi","row":"ChatWifiBox_row__2hnAN","submitButton":"ChatWifiBox_submitButton__3Zrq6"};